import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      const isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
      const minSide = Math.min(window.innerWidth, window.innerHeight);
      const isSmallViewport = window.innerWidth < MOBILE_BREAKPOINT;
      const isHandheldLandscape = isCoarsePointer && minSide < MOBILE_BREAKPOINT;
      setIsMobile(isSmallViewport || isHandheldLandscape);
    };
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}

/** Raw value: undefined until after first effect (hydration). Use in route guards to avoid redirecting before mobile is known. */
export function useIsMobileState(): boolean | undefined {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      const isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
      const minSide = Math.min(window.innerWidth, window.innerHeight);
      const isSmallViewport = window.innerWidth < MOBILE_BREAKPOINT;
      const isHandheldLandscape = isCoarsePointer && minSide < MOBILE_BREAKPOINT;
      setIsMobile(isSmallViewport || isHandheldLandscape);
    };
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
